import { scrollTop } from "../lib/smooth";
import Reveal from "./Reveal";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="border-t border-olive/30">
            <Reveal>
                <a
                    href="mailto:mashijmusic@gmail.com"
                    data-testid="footer-contact-email"
                    className="block px-5 md:px-10 py-14 md:py-24 max-w-[1600px] mx-auto w-full group"
                >
                    <p className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-tulip mb-4 md:mb-6">Contact</p>
                    <p className="font-display font-extrabold uppercase tracking-[-0.02em] leading-[0.95] text-[clamp(1.5rem,6vw,5.5rem)] text-blush group-hover:text-tulip transition-colors duration-300 break-all">
                        mashijmusic@gmail.com
                    </p>
                </a>
            </Reveal>
            <div className="px-5 md:px-10 pb-10 max-w-[1600px] mx-auto w-full flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[10px] md:text-xs uppercase tracking-[0.2em] text-blush/50">
                <span data-testid="footer-copyright">© {year} Mashi J — All rights reserved</span>
                <a
                    href="/privacy"
                    data-testid="footer-privacy-link"
                    className="uppercase tracking-[0.2em] text-blush/60 hover:text-tulip transition-colors duration-200"
                >
                    Privacy
                </a>
                <button
                    type="button"
                    data-testid="footer-back-to-top"
                    onClick={scrollTop}
                    className="uppercase tracking-[0.2em] text-blush/60 hover:text-tulip transition-colors duration-200"
                >
                    Back to top ↑
                </button>
            </div>
        </footer>
    );
}
